import { render, staticRenderFns } from "./pages.content.vue?vue&type=template&id=00d2984a"
import script from "./pages.content.vue?vue&type=script&lang=js"
export * from "./pages.content.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports